import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";

const ZoneDetailsModal = ({ zone, open, onClose }) => {
  console.log(zone);
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <DialogTitle>{"Zone Details"}</DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Name
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={zone?.name || ""}
                InputProps={{
                  readOnly: true,
                  style: {
                    color: "var(--text-primary)",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Code
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={zone?.code || ""}
                InputProps={{
                  readOnly: true,
                  style: {
                    color: "var(--text-primary)",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Zip
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={zone?.zip || ""}
                InputProps={{
                  readOnly: true,
                  style: {
                    color: "var(--text-primary)",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 10 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ZoneDetailsModal;
